module.exports = __webpack_public_path__ + "img/c_recurring charges.1cb75d05.svg";